import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-video',
  templateUrl: "./youtube-video.component.html",
  styleUrl: "./youtube-video.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YoutubeVideo implements OnInit {
  public readonly sanitize = inject(DomSanitizer);

  /** Variable de entrada que recibe del componente padre la url del video a renderizar*/
  readonly videoEmbed = input<string>('');

  /** Variable de entrada que recibe del componente padre la altura del componente que renderizara el video*/
  readonly height = input<string>('550');

  /** Variable de entrada que recibe de un componente padre si el video es de tammaño completo o no*/
  readonly full = input<boolean>(false);

  /** Variable que guardara la url del video saneado*/
  protected readonly resourceUrl = signal<SafeResourceUrl>('');

  /** HostBindinig: permite establecer propiedades en el elemento o componente, en este caso definir clases Css sobre el mismo*/
  @HostBinding('class') class = 'youtube-container';

  /** @ignore*/
  constructor() {}

  /**
   * función nativa de angular que se activa despues de que se cargue el constructor, en este
   * caso es el encargado de generar la url segura para poder renderizar el video de youtube
   * y asi evitar inyecciones maliciosas de código.
   */
  ngOnInit(): void {
    const url = this.sanitize.bypassSecurityTrustResourceUrl(this.videoEmbed());
    this.resourceUrl.set(url);
  }
}
